import { Tson } from '~/data/Tson'
import { AssistedValueJson } from '~/data/workflow/assist/AssistedValueJson'

export function mapToAssistedValueJson(tson: Tson): AssistedValueJson {
  return {
    label: tson.getString('label'),
    value: tson.getValue('value').asIs(),
  }
}
